import http from "@/utils/http";
let hr = "/hrApi";
export default {
  placeCreate: (data) => http.post(`${hr}/bu/admin/placeCreate`, data), // 借伞地点创建
  placeList: (data) => http.post(`${hr}/bu/admin/placeList`, data), // 借伞地点列表
  stockList: (data) => http.post(`${hr}/bu/admin/stockList`, data), // 库存管理列表
  addStock: (data) => http.post(`${hr}/bu/admin/addStock`, data), // 增加伞库存
  reduceStock: (data) => http.post(`${hr}/bu/admin/reduceStock`, data), // 减少伞库存
  buApply: (data) => http.post(`${hr}/bu/buApply`, data), // 借伞申请
  myRecordList: (data) => http.post(`${hr}/bu/myRecordList`, data), // 借伞记录
  recordList: (data) => http.post(`${hr}/bu/admin/recordList`, data), // 全部/待确认借还列表
  returnList: (data) => http.post(`${hr}/bu/admin/returnList`, data), // 归还列表
  buReturn: (data) => http.post(`${hr}/bu/buReturn`, data), // 归还雨伞
  confirmReturn: (data) => http.post(`${hr}/bu/admin/confirmReturn`, data), // 确认归还
  recordDetail: (data) => http.post(`${hr}/bu/admin/recordDetail`, data), // 借伞详情
  buTiming: (data) => http.post(`${hr}/bu/buTiming`, data), // 定时信息获取
  buSetTiming: (data) => http.post(`${hr}/bu/buSetTiming`, data), // 定时信息设置
  buDetail: (data) => http.post(`${hr}/bu/admin/buDetail`, data), // 定时信息设置
};